import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { startLogin } from '../actions/auth';
import Button from '@mui/material/Button';
import { orange } from '@mui/material/colors';

export const LoginPage = (props) => {

    const primary=orange[800];
    const navigate=useNavigate();

    return (
        <div className='login-page d-flex justify-content-center align-items-center'>

            <div className='login-box text-center'>

                <img src="./images/icon.png" alt="" className='extensify-icon' />
                <h1 className='app-name'>Extensify</h1>
                <p className='app-detail'>It's time to get your expenses under control.</p>

                <Button 
                    variant='contained'
                    className='login-logout-button'
                    style={{backgroundColor:primary}}
                    onClick={async ()=>{
                        await props.startLogin();
                        navigate('/dashboard');
                    }}
                >Login</Button>
            </div>
        </div>
    );
}

const mapDispatchToProps = (dispatch) => ({
    startLogin: () => dispatch(startLogin())
});

export default connect(undefined, mapDispatchToProps)(LoginPage);